import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingOverlayWrapper = ({
  children,
  loading
}) => {
  if (!loading) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(LoadingOverlay, {
    contextual: true,
    "data-test-id": "loading-spinner"
  });
};
export default LoadingOverlayWrapper;